import { useCallback, useEffect, useState } from 'react';
export const useSearch = ({ search, initialCategory, interactionState, inputRef, }) => {
    const [isSearched, setIsSearched] = useState(false);
    const [inputValue, setInputValue] = useState(initialCategory?.name || '');
    useEffect(() => {
        if (interactionState === 'input' && !isSearched) {
            setInputValue(initialCategory?.name || '');
        }
    }, [initialCategory, interactionState, isSearched]);
    useEffect(() => {
        if (interactionState === 'input') {
            setInputValue(initialCategory?.name || '');
            inputRef.current?.focus();
        }
        if (!interactionState) {
            resetSearch();
        }
    }, [interactionState, initialCategory]);
    const handleSearchChange = useCallback((e) => {
        setIsSearched(true);
        search.onChange(e.target.value);
    }, [search]);
    const resetSearch = useCallback(() => {
        search.onChange('');
        setIsSearched(false);
    }, [search]);
    return {
        isSearched,
        inputValue,
        handleSearchChange,
        resetSearch,
    };
};
